import { MenuItem, Select } from "@mui/material";
import {
  Leave,
  LeaveEntity,
  LeaveEntityDateRange,
} from "../../../../entriesAPI";
import {
  continuedLeaveDateString,
  isAllowedContinuationOfTypeFor,
} from "../../../Shared/functions";

interface Props {
  leaveEntity: LeaveEntity;
  updateLeaveEntity: (
    key: string,
    value: string | LeaveEntityDateRange | null | Leave,
  ) => void;
}

const PreviousLeaves = ({ leaveEntity, updateLeaveEntity }: Props) => {
  const findChain = (rootId: string) => {
    const chain = leaveEntity.previousLeaves.chains[rootId];
    if (chain) {
      return chain.filter((cl) => cl.id !== leaveEntity.id); //.length > 1 ? leaveEntity.previousLeaves.chains[rootId].filter(cl => cl.id !== leaveEntity.id) : leaveEntity.previousLeaves.chains[rootId]; // remove ourself
    }
    console.log("WARN no chain");
    return [];
  };
  const menuItems = () => {
    const entries = leaveEntity.previousLeaves.order;

    // filter current leave out
    const ret = entries
      .filter((e) => e !== leaveEntity.id)
      .map((rootId) => {
        if (
          isAllowedContinuationOfTypeFor(
            leaveEntity.type,
            leaveEntity.previousLeaves.chains[rootId][0]?.type,
          )
        ) {
          const chain = findChain(rootId);
          return (
            <MenuItem key={rootId} value={rootId}>
              {continuedLeaveDateString(chain)}
            </MenuItem>
          );
        } else return [];
      });

    //console.log("ret", ret)
    return ret.filter((item) => item !== undefined);
  };

  return (
    <Select
      size="small"
      fullWidth
      displayEmpty
      value={leaveEntity?.continuationOf?.id || ""}
      onChange={(e) => {
        //console.log("selecting entry", e.target.value)
        updateLeaveEntity("continuationOfId", e.target.value);
        const leaves = leaveEntity.previousLeaves.chains[e.target.value];
        if (leaves === undefined) {
          updateLeaveEntity("continuationOfId", null);
          return updateLeaveEntity("continuationOf", null);
        }
        const last = leaves.length - 1;
        if (last === -1) {
          updateLeaveEntity("continuationOfId", null);
          return updateLeaveEntity("continuationOf", null);
        }
        // TODO VK maybe get rid of continuationOf or continuationOfId? Somewhat duplicate.
        const leave = leaves[last];
        updateLeaveEntity("continuationOf", leave);
        updateLeaveEntity("continuationOfId", leave.continuationOf ?? leave.id);
      }}
      sx={{
        marginTop: "15px",
        backgroundColor: "rgba(249, 249, 250, 0.6)",
      }}
      renderValue={() => {
        const leaveId =
          leaveEntity.continuationOfId ?? leaveEntity.continuationOf?.id;
        if (!leaveId) {
          return "";
        }
        const cont = findChain(leaveId); //leaveEntity.previousLeaves.chains[leaveId];//?.filter(cl => cl.id !== leaveEntity.id) ?? [];
        return continuedLeaveDateString(cont);
      }}
    >
      {menuItems()}
    </Select>
  );
};

export default PreviousLeaves;
